import { useState, useEffect } from 'react';
import LeadCard from '../../components/qualifier/LeadCard';
import ReassignDemo from './ReassignDemo';
import {getSellerObjections, getSellerDeclinedReasons, getTeamDemosPending, getDemoQualifierAnswers, openedLeadCard, getTeamDemosCancelled} from '../../utils/api';
import { refresh, getCurrentUser } from '../../services/auth.service';
import close from '../../assets/design/dashboard/close.png';
import iconCompanyDefault from '../../assets/companylogos/default.png';
import Spinner from '../../components/layout/Spinner';
import { FaFireAlt, FaUsers, FaClock, FaRegBell, FaEnvelope, FaEllipsisV, FaTimes } from "react-icons/fa";
import FadeIn from '../../utils/fadein';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';

const SellerDemosCancelled = () => {
  const imagePath = process.env.REACT_APP_IMAGE_PATH;
  const [showDeclinedPopup, setShowDeclinedPopup] = useState(false);
  const [sellerObjections, setSellerObjections] = useState([]);
  const [currentDemo, setCurrentDemo] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const [showQualifierAnswers, setShowQualifierAnswers] = useState(false);
  const [sellerDeclinedReasons, setSellerDeclinedReasons] = useState([]);
  const [hasDemos, setHasDemos] = useState(false);
  const [showReassign, setShowReassign] = useState(false);
  const [demos, setDemos] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [showExpiresModal, setShowExpiresModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const currentUser = getCurrentUser();
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseimageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const navigate = useNavigate();

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    let _domain = 'domain=leadrpro.com';
    document.cookie =
      cname + '=' + cvalue + ';' + _domain + ';' + expires + ';path=/';
  }

  async function handleToggleMenu(item){
    if (item.demo_id !== currentDemo.demo_id){
      setCurrentDemo(item);
      setShowSubMenu(true);
    }

    else{
      setCurrentDemo(item);
      setShowSubMenu(!showSubMenu);
    }
  }

  useEffect(() => {
    async function loadTeamDemos(){
      let res = await getTeamDemosCancelled();

      if (res.success){
        setDemos(res.data);
        setLoaded(true);
      }

      else if (res.status === 403){
        await refresh();

        let res = await getTeamDemosCancelled();

        if (res.success){
          setDemos(res.data);
        }

        setLoaded(true);
      }
    }

    loadTeamDemos();
  }, []);

  async function refreshDemos(){
    let res = await getTeamDemosCancelled();

    if (res.success){
      setDemos(res.data);
      setLoaded(true);
    }

    else if (res.status === 403){
      await refresh();

      let res = await getTeamDemosCancelled();

      if (res.success){
        setDemos(res.data);
      }

      setLoaded(true);
    }
  }

  useEffect(() => {
    let _filter = demos.filter(item => item.buyer_status === 'Approved' && item.seller_status === 'Pending');

    if (_filter.length > 0){
      setHasDemos(true);
    }

    else{
      setHasDemos(false);
    }
  }, [demos]);

  async function handleAnswersClick(item) {
    setLoading(true);
    setSelectedId(item.demo_id);

    let res = await getDemoQualifierAnswers(item.demo_id);

    if (res.success){
      let new_item = {...item, qualifier_answers: res.data};
      setCurrentDemo(new_item);
      setShowQualifierAnswers(true);
      setLoading(false);
      setShowSubMenu(false);
    }

    else if (res.status === 403){
      await refresh();
      let res = await getDemoQualifierAnswers(item.demo_id);

      if (res.success){
        let new_item = {...item, qualifier_answers: res.data};
        setCurrentDemo(new_item);
        setShowQualifierAnswers(true);
        setLoading(false);
        setShowSubMenu(false);
      }
    }

    await openedLeadCard(item.demo_id);
  }

  async function handleReassignClick(demo) {
    setCurrentDemo(demo);
    setShowReassign(true);
    setShowSubMenu(false);
  }

  function addDays(d, days){
    const result = new Date(d);
    result.setDate(result.getDate() + days);
    return result;
  }

  // if date sent was over 14 days ago
  function isExpiring(d, last_date){
    let date = new Date();
    let newDate = addDays(date, -14);
    let between = daysBetweenDates(date, last_date);

  }

  function daysBetweenDates(date1, date2) {
    const millisecondsPerHour = 60 * 60 * 1000; // 1 hour = 60 minutes * 60 seconds * 1000 milliseconds
    const differenceInMilliseconds = date2 - date1; // Get the absolute difference in milliseconds
    const hours = differenceInMilliseconds / millisecondsPerHour; // Convert milliseconds to hours
    return Math.floor(hours / 24);
  }

  return (
    <>
    <div>
      {loaded === false && (
        <div className='center'>
          <Spinner />
        </div>
      )}

      {demos.length === 0 && loaded === true && (
          <div className='dashboarddemo__no-results'>
            <div className="bg-white rounded-lg shadow-sm p-12 text-center">
              <div className="flex justify-center mb-4">
                <User className="h-16 w-16 text-gray-300" />
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">No cancelled demo requests</h3>

            </div>
          </div>
        )}

      {loaded && demos.length > 0 && (
        <>
          <div className="mb-4 bg-white rounded-lg p-4 shadow-sm">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-lg font-medium text-gray-900">
                  Total Cancelled Demos:
                </span>
                <span className="bg-red-100 text-red-700 px-2.5 py-0.5 rounded-full font-semibold">
                  {demos.length}
                </span>
              </div>
            </div>
          </div>

          <div className='dashboard__table-wrapper'>
        <table className='table dashboard__table'>
          <tr>
            <th></th>
            <th>Company</th>
            <th>Date applied</th>
            <th>Reason</th>
            <th>Assigned to</th>
            <th></th>
          </tr>
          {(demos.sort((a, b) => new Date(b.date_applied) - new Date(a.date_applied)))
          .map((item, index) => (
            <tr key={index}>
              <td>
                  <div className='dashboard__table-company-logo'>
                    <img src={imageUrl +'tr:di-@@companylogos@@default-buyer.png/' + item.logo} />
                  </div>
              </td>

              <td>
                  <div className='dashboarddemo__company-name'>
                    {item.first_name && item.first_name.length > 0 && (
                      <div className='dashboarddemo__name'>
                        <span className='text-base font-semibold text-gray-900 hover:text-blue-600 transition-colors'>
                          {item.first_name} {item.last_name}
                        </span>
                      </div>
                    )}

                    <span className='text-sm text-gray-600 mt-0.5 block'>
                      {item.job_title && item.job_title.length > 0 ? (
                        <span>{item.job_title}</span>
                      ) : (
                        <span>{item.persona_type}</span>
                      )} at <span className="font-medium">{item.company_name}</span>
                    </span>
                  </div>
                </td>

                    <td className='dashboarddemo__company-info'>
                      <div className='dashboarddemo__company-info-items'>
                        <div className='dashboarddemo__company-info-item'>
                          <div style={{fontSize: '12px'}}>
                            <span className='dashboarddemo__company-info-label'>Applied on: </span>
                            <span>{new Date(item.date_applied).toLocaleDateString()}</span>
                          </div>

                          <div>
                            {isExpiring(new Date(item.date_applied), new Date(item.last_date_to_approve))}
                          </div>
                        </div>
                      </div>
                    </td>


                    <td>
                      <div className='text-sm text-gray-600'>
                        {item.reason || 'No reason provided'}
                      </div>
                    </td>

                    <td>
                      <div className='center'>
                        <div>
                          <div className='dashboarddemo__team-member-profile-image' style={{display:"inline-block"}}>
                          {item.seller_profile_image && item.seller_profile_image != '' && (
                            <img src={baseimageUrl + 'profileimages/' + item.seller_profile_image} alt="logo found" />
                          )}

                          {!item.seller_profile_image && (
                            <img src={iconCompanyDefault} alt="logo not found" />
                          )}
                          </div>
                          <div style={{fontSize: "12px"}}>
                            {item.seller_first_name} {(item.seller_last_name && item.seller_last_name.length > 0) ? item.seller_last_name.substring(0, 1) +'.' : '' }
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div style={{position: 'relative'}}>
                    <span className='dashboard__submenu-icon' onClick={() => handleToggleMenu(item)}>
                      <FaEllipsisV />
                    </span>

                    {showSubMenu == true && currentDemo.demo_id == item.demo_id && (
                      <FadeIn delay={100} duration={100}>
                    <div className='dashboard__submenu'>
                      <div className='dashboard__submenu-item' onClick={() => handleAnswersClick(item)}>Buyer Details</div>

                    </div>
                    </FadeIn>
                    )}
                    </div>
                  </td>
            </tr>
          ))}
          </table>
          </div>
          </>
      )}
      </div>

        {showReassign===true && (
          <>
            <div className='overlay'></div>
            <div className='modal'>
              <div className='modal__close' onClick={() => setShowReassign(false)}>
                <FaTimes />
              </div>

              <ReassignDemo demo_id={currentDemo.demo_id} demos={demos} setDemos={setDemos} refresh={refreshDemos} />
            </div>
          </>
        )}

        {showExpiresModal && (
          <>
            <div className='overlay'></div>
            <div className='modal'>
              <div className='modal__close' onClick={() => setShowExpiresModal(false)}>
                <FaTimes />
              </div>

              <h2 className='modal__h2'>
                Submitted times expired
              </h2>

              <div style={{marginTop: '10px'}}>
                The available times submitted for this demo application have expired. If you would still like to meet with this person, you will need to submit a reschedule request.
              </div>
            </div>
          </>
        )}

      {showQualifierAnswers && (
        <>
          <div className='overlay'></div>
          <LeadCard currentDemo={currentDemo} setShowQualifierAnswers={setShowQualifierAnswers} setShowDeclinedPopup={setShowDeclinedPopup} demos={demos} setDemos={setDemos} show_buttons={false} />
        </>
      )}
    </>
  )
}

  export default  SellerDemosCancelled;